import { IKiwiInstitution } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { KiwiInstitutionChannel } from 'src/app/business/kiwi-institution/contracts/kiwi-institution.channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { KiwiInstitutionModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class KiwiInstitutionSyncService extends SyncService<IKiwiInstitution> {
    constructor(
        @Inject(AppController) appController: IAppController,
        @Inject(Dispatcher) dispatcher: IDispatcher<IKiwiInstitution>,
        eventService: EventService<SyncProgressEvent>,
        ngZone: NgZone,
        @Inject(PlatformSyncToken) platformSync: IPlatformSync
    ) {
        super(KiwiInstitutionModelName, appController, dispatcher, eventService, ngZone, platformSync);
    }

    public canSync(channel: string): boolean {
        return channel === KiwiInstitutionChannel.CREATE ||
               channel === KiwiInstitutionChannel.EDIT ||
               channel === KiwiInstitutionChannel.DELETE;
    }
}
